import React, { Suspense, lazy } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router';

import ProfileDetailPage from '../containers/profile/views/profile.index';
import SettingsIndexPage from '../containers/settings/settings.index';
import WebSocketElement from '../services/websocket';

import Spinner from '../components/Spinner';

const CustomerDetailPage = lazy(() => import('../containers/customers/views/customer.index'/* webpackChunkName: "CustomerDetailPage" */));
const CustomerPage = lazy(() => import('../containers/customers/index'/* webpackChunkName: "CustomerPage" */));
const NotFound = lazy(() => import('../components/Notfound'));
const HomePageView = lazy(() => import('../containers/home/'));
const Login = lazy(() => import('./../containers/account.login'));
const AdminDashBoard = lazy(() => import('../containers/dashboard/admin.dashboard'));
const RequestPasswordPage = lazy(() => import('../containers/account.request.password'));
const SignupPage = lazy(() => import('../containers/account.signup'));
const ChangePasswordPage = lazy(() => import('../containers/account.change.password'));
const AccountActivation = lazy(() => import('../containers/account.activate'));
const ExchangesView = lazy(() => import('../containers/exchanges'));
const StrategiesIndex = lazy(() => import('./../containers/strategies/views/strategies.index'));
const StrategiesDetailView = lazy(() => import('./../containers/strategies/views/strategies.detail.view'));
const ErrorPage = lazy(() => import('../components/error'/* webpackChunkName: "ErrorPage" */));
const FinancialPage = lazy(() => import('../containers/financial/financial.index'/* webpackChunkName: "FinancialPage" */));
const FinancialDashoard = lazy(() => import('../containers/financial/financial.dashboard'/* webpackChunkName: "FinancialPage" */));
const InvoiceDetailPage = lazy(() => import('../containers/financial/invoice.detail.index'/* webpackChunkName: "InvoiceDetailPage" */));
const PaymentPage = lazy(() => import('../containers/financial/payment.page'/* webpackChunkName: "PaymentPage" */));
const InvoiceAddPage = lazy(() => import('../containers/financial/invoice.add/invoice.add'/* webpackChunkName: "InvoiceAddPage" */));
const InvoiceEditPage = lazy(() => import('../containers/financial/invoice.add/invoice.edit'/* webpackChunkName: "InvoiceEditPage" */));
// const SubscriptionsIndexPage = lazy(() => import('../containers/subscriptions/subscriptions.index'/* webpackChunkName: "SubscriptionsIndexPage" */));
// const SubscriptionDetailIndex = lazy(() => import('../containers/subscriptions/subscription.details/subscription.details.index'/* webpackChunkName: "SubscriptionDetailIndex" */));

const TradeManagerIndex = lazy(() => import('./../containers/trade-manager/views/trades.index'));
const BacktestIndex = lazy(() => import('./../containers/backtest/views/backtest.index'));
const JournalsIndex = lazy(() => import('./../containers/journals'));
const JournalSheetDetail = lazy(() => import('./../containers/journals/views/journal.sheet.detail'));
const JournalSheetPublicDetail = lazy(() => import('./../containers/journals/views/journal.sheet.public.detail'));
const KbRouter = lazy(() => import('../containers/kb'/* webpackChunkName: "KbRouter" */));

const Routers = ({ ...props }) => {
    const { locale, setCurrentLanguage } = props;
    const language_props = { locale, setCurrentLanguage };

    return (
        <Suspense fallback={<Spinner />}>
            <BrowserRouter>
                <WebSocketElement {...language_props} {...props} />
                <Routes>
                    {/* <Route path="/" exact element={HomePageView} /> */}
                    {/* <Route index path="/" render={props => { return <HomePageView {...language_props} {...props} />; }} /> */}
                    <Route index element={<HomePageView {...language_props} {...props} />} />

                    <Route path="login" exact element={<Login {...language_props} {...props} />} />
                    <Route path="login/:mail/:token" element={<Login {...language_props} {...props} />} />
                    <Route path="login/location_validation/:mail/:token" element={<Login {...language_props} {...props} />} />
                    <Route path="dashboard" element={<AdminDashBoard {...language_props} {...props} />} />
                    <Route path="request-password" element={<RequestPasswordPage {...language_props} {...props} />} />
                    <Route path="change-password" element={<ChangePasswordPage {...language_props} {...props} />} />
                    <Route path="activation/:code" element={<AccountActivation {...language_props} {...props} />} />
                    <Route path="signup" exact element={<SignupPage {...language_props} {...props} />} />
                    <Route path="signup/:code" element={<SignupPage {...language_props} {...props} />} />
                    <Route path="profile" exact element={<ProfileDetailPage {...language_props} {...props} />} />
                    <Route path="profile/:tab" element={<ProfileDetailPage {...language_props} {...props} />} />

                    <Route path="system" exact element={<SettingsIndexPage {...language_props} {...props} />} />
                    <Route path="system/:tab" element={<SettingsIndexPage {...language_props} {...props} />} />

                    <Route path="customers" element={<CustomerPage  {...language_props}{...props} />} />
                    <Route path="customer/details/:customer_id/:tab" element={<CustomerDetailPage {...language_props} {...props} />} />
                    <Route path="customer/details/:customer_id" element={<CustomerDetailPage {...language_props} {...props} />} />

                    <Route path="finance" element={<FinancialDashoard {...language_props} {...props} />} />
                    <Route path="finance/:tab" element={<FinancialPage {...language_props} {...props} />} />
                    <Route path="finance/add/:customer_id" element={<InvoiceAddPage {...language_props} {...props} />} />
                    <Route path="payment/:code" element={<PaymentPage {...language_props} {...props} />} />

                    <Route path="invoice/:invoice_id" element={<InvoiceDetailPage {...language_props} {...props} />} />
                    <Route path="invoice/:invoice_id/:tab" element={<InvoiceDetailPage {...language_props} {...props} />} />
                    <Route path="invoice/edit/:invoice_id" element={<InvoiceEditPage {...language_props} {...props} />} />

                    <Route path="strategies" exact element={<StrategiesIndex {...language_props} {...props} />} />
                    <Route path="strategy/:strategy_id/:tab" element={<StrategiesDetailView {...language_props} {...props} />} />

                    <Route path="/trades" exact element={<TradeManagerIndex {...language_props} {...props} />} />
                    <Route path="/trades/t/:tab" exact element={<TradeManagerIndex {...language_props} {...props} />} />
                    <Route path="/trades/t/:tab/:action" exact element={<TradeManagerIndex {...language_props} {...props} />} />
                    <Route path="/trades/t/:tab/:action/:trade_id" exact element={<TradeManagerIndex {...language_props} {...props} />} />

                    <Route path="/journals" exact element={<JournalsIndex {...language_props} {...props} />} />
                    <Route path="/journals/:sheet_id" exact element={<JournalSheetDetail {...language_props} {...props} />} />

                    <Route path="/backtest" exact element={<BacktestIndex {...language_props} {...props} />} />
                    <Route path="/backtest/:tab" exact element={<BacktestIndex {...language_props} {...props} />} />

                    <Route path="/journal_public/:sheet_id" exact element={<JournalSheetPublicDetail {...language_props} {...props} />} />

                    <Route path="profile" element={<ProfileDetailPage {...language_props} {...props} />} />
                    <Route path="profile/:tab" element={<ProfileDetailPage {...language_props} {...props} />} />

                    <Route path="/brokers" exact element={<ExchangesView {...language_props} {...props} />} />
                    <Route path="/brokers/ctrader_connect" exact element={<ExchangesView {...language_props} {...props} />} />
                    <Route path="/brokers/:tab" exact element={<ExchangesView {...language_props} {...props} />} />

                    {/* <Route path="/instruments" exact element={<InstrumentsIndex {...language_props} {...props} />} /> */}
                    {/* http://localhost:3000/exchanges/ctrader_connect?code=194eabe58038912929c62849e99c62edd800d27fb7b2e3d6d460e88b870b5140b2343022619a726256b790 */}

                    {/* <Route path="/order/details/:order_id" exact element={OrderDetailView} />
                <Route path="/order/details/:order_id/:tab" exact element={OrderDetailView} /> */}

                    <Route path="kb/*" element={<KbRouter {...language_props} {...props} />} />

                    <Route path="connection_error" element={<ErrorPage {...language_props} {...props} />} />

                    <Route path="*" element={<NotFound {...language_props} {...props} />} />
                </Routes >
            </BrowserRouter >
        </Suspense >
    );
};

export default Routers;